// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: '/api/v1',
  topologyUrl: '/api/v1',
  financialUrl: '/api/v1',
  schedulesUrl: '/api/v1/schedules',
  vppUrl: '/api/v1/vpp',
  userUrl: '/api/v1/users',
  local_des_session: 'THIS-IS-A-FAKE',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
